export default __webpack_public_path__ + "static/logo_white-af039893af3458956fecc26e81f43a1b.svg";